import { FieldFormatType } from '@vista/omnichannel-components-ui'
import {OccFormConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/form/form'

export function getFormConfigData():OccFormConfig {
    return {
        enableFloatingInputLabels: false,
        fieldValidation: {
            password: {
                type: FieldFormatType.Password,
                maxLength: 64,
                required: true,
                rules: [
                    {
                        displayText: 'Uppercase letter',
                        regExpression: '([A-Z])',
                    },
                    {
                        displayText: 'Lowercase letter',
                        regExpression: '([a-z])',
                    },
                    {
                        displayText: 'Numeric character',
                        regExpression: '([0-9])',
                    },
                    {
                        displayText: 'Between 8 and 64 characters',
                        regExpression: '^.{8,64}$',
                    },
                    {
                        displayText: 'At least 1 special character',
                        regExpression: '[\'*.!@#$%^&(){}:;<>,.?/~_+\\\-=|"`¬£]',
                    },
                ],
            }
        }
    }
}